import { default_client } from '@/modules/clients/services';
import { Mutations } from 'vuex-smart-module';
import { Clients } from '../../../types';
import ClientDetailState from './state';

export default class ClientDetailMutations extends Mutations<ClientDetailState> {
  SET_CURRENT_CLIENT(data: Clients.Client) {
    this.state.current_client = data;
  }

  UPDATE_EDITABLE_CLIENT({ key, value } : { key: keyof Clients.Client, value: unknown }) {
    this.state.editable_client[key] = value;
  }

  RESET_EDITABLE_CLIENT() {
    this.state.editable_client = { ...this.state.current_client };
  }

  RESET_CURRENT_CLIENT() {
    this.state.current_client = default_client();
  }
}
